import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./components/AppRoutes";
import FloatingMenu from "./components/FloatingMenu";
import { LayoutProvider } from "./components/LayoutContext";
import Placeholder from "./components/Placeholder";
import "./styles/index.css";
import "./styles/App.css";

/*function Home() {
  return <h1>Welcome to the Home Page</h1>;
}*/

function App() {
  //const isPlaceholder = process.env.REACT_APP_SHOW_PLACEHOLDER === 'true';
  const [isPlaceholder] = useState(false);

  return (
    <div className="App">
      {isPlaceholder ? (
        <Placeholder />
      ) : (
        <Router>
          <LayoutProvider>
            <AppRoutes />
            <FloatingMenu />
          </LayoutProvider>
        </Router>
      )}
    </div>
  );
}

export default App;
